import { render, staticRenderFns } from "./WebPushSettings.vue?vue&type=template&id=12e665dc&"
import script from "./WebPushSettings.vue?vue&type=script&lang=ts&"
export * from "./WebPushSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports